import i18n from '@dms/i18n';
import {TypographyCard} from '@dms/teas';

import {BankAccounts} from './BankAccounts';
import {DeputyPersons} from './DeputyPersons';

export const BankInformation = () => (
  <TypographyCard title={i18n.t('entity.bank.labels.bankInformation')}>
    <DeputyPersons />
    <BankAccounts />
  </TypographyCard>
);
